module.exports = __webpack_public_path__ + "static/media/LogoBusinessReportsTransGray.c7d9ab73.png";